import { render, staticRenderFns } from "./adminbasics.vue?vue&type=template&id=64ca6d6b&scoped=true"
import script from "./adminbasics.vue?vue&type=script&lang=js"
export * from "./adminbasics.vue?vue&type=script&lang=js"
import style0 from "./adminbasics.vue?vue&type=style&index=0&id=64ca6d6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca6d6b",
  null
  
)

export default component.exports